import React from 'react'
import '../css/Footer.css'
import { Link } from 'react-router-dom'

function Footer() {
  return (
    <div id="footer">
            <div className="text-center">
              © All Rights Reserved.
            </div>
    </div>
  )
}

export default Footer
